// Данные кабинета (S — как пришли с сервера) и состояние экранов (UI): что открыто, что выбрано, черновики.
import type { AppState, ClientOut, GroupOut, MeetKind } from '@praktika/core';

export let S: AppState = null as unknown as AppState;

export function setS(s: AppState): void {
  S = s;
}

export interface BookDraft {
  key: string; clientId: string; typeId: string; date: string; time: number | null; meet: MeetKind | ''; link: string;
  address: string; price: number | ''; repeat: number; every: number | 'month'; note: string; tzView: string;
  reserve: boolean; variants: Array<{ date: string; time: number }>;
}

export interface UiState {
  schedDay: string | null;
  schedMode?: 'week' | 'month';
  book: BookDraft | null;
  move?: { id: string; date: string; time: number | null } | null;
  edit?: { id: string; typeId: string | null; price: number | null; meet: MeetKind | ''; link: string; address: string;
    note: string; groupId: string; cur: string } | null;
  moneySeg: 'pay' | 'review' | 'rc' | 'tot';
  moneyMonth: string | null;
  money: MoneyView | null;
  clientSeg: 'personal' | 'projects' | 'archive';
  search: string;
  csort: string;
  expandTimes: boolean;
  zoom?: string;
  ppm?: number;
  ppmNow?: number;
  tlTop?: number;
  _refit?: boolean;
  tzOff?: Record<string, boolean>;
  draftClient?: ClientDraft | null;
  draftGroup?: GroupDraft | null;
  histAll?: string;              // карточка клиента: показаны все его сессии (номер клиента)
}

// Новый клиент и новая группа до сохранения: те же поля, что в карточке.
export type ClientDraft = Pick<ClientOut, 'name' | 'callName' | 'groupId' | 'typeId' | 'price' | 'cur' | 'meet' | 'link' |
  'makeMeet' | 'address' | 'tz' | 'slotDay' | 'slotTime' | 'contact' | 'messenger' | 'bankNames' | 'ownRules' |
  'ruleHours' | 'ruleLate' | 'ruleNoShow' | 'note' | 'color'>;
export type GroupDraft = Pick<GroupOut, 'name' | 'kind' | 'cur' | 'typeId' | 'pays' | 'payDay' | 'selfReceipt' | 'meet' |
  'link' | 'messenger' | 'price' | 'inn' | 'bankNames' | 'contact' | 'note' | 'color' | 'ruleHours' | 'ruleLate' |
  'ruleNoShow' | 'calCodes'>;

// Ответ сервера «Деньги за месяц».
export interface MoneyView {
  month: string;
  payments: AppState['payments'];
  totals: {
    personal: { sessions: number; chargedMain: number; chargedSec: number; paidMain: number; debtMain: number;
      debtors: string[] };
    projects: Array<{ id: string; name: string; cur: string; sessions: number; charged: number; chargedSec: number;
      paid: number; balance: number; pays: string; payDay: number | null }>;
    total: { sessions: number; chargedMain: number; chargedSec: number; paidMain: number; paidSec: number };
    receivedMain: number; receivedSec: number; main: string; sec: string;
  };
  receipts: Array<{ id: string; date: string; amount: number; cur: string; buyer: string; kind: string; service: string;
    due: string; status: string; link: string }>;
  taxEstimate: number;
  months: string[];
}

export const UI: UiState = {
  schedDay: null, book: null, moneySeg: 'pay', moneyMonth: null, money: null, clientSeg: 'personal', search: '',
  csort: 'name', expandTimes: false,
};

export interface Screen { name: string; p: Record<string, unknown> }
export const NAV: { tab: string; stack: Screen[] } = { tab: 'today', stack: [] };
